import React from 'react';
import { useDataContext } from 'common/lib/helpers/DataContext';
import * as _ from 'lodash';
import { formatPriceLabel } from 'common/lib/helpers/formatPrice';
import { NO_IMAGE_SRC } from 'common/lib/helpers/constants';
import { Card, Clickable } from '@fabric-ds/react';
import { getUnits } from '../unitSelector/unitFilter';

const HighlightedUnits = () => {
    const { layoutPath, imageHost } = useDataContext();
    const { units } = getUnits(null, false, false);

    const highlightedUnits = units.filter(unit => unit.isHighlighted === true);

    const unitPreview = unit => {
        const { finnkode, apartmentNumber, bedrooms, floor, totalPrice, primaryRoomArea, images, floorPlans, heading } =
            unit;

        const imageList = () => {
            if (floorPlans && images) {
                return images.concat(floorPlans);
            }
            if (!floorPlans && images) {
                return images;
            }
            if (floorPlans && !images) {
                return floorPlans;
            }
            return [];
        };

        const imagePath = !_.isEmpty(imageList())
            ? `${imageHost}/dynamic/480x480c/${imageList()[0].path}`
            : NO_IMAGE_SRC;

        return (
            <Card key={finnkode} className>
                <div aria-owns="title" />

                <img className="h-128 w-full object-cover " src={imagePath} alt="Bilde av utvalgt enhet" />

                <div className="p-16">
                    <p className="text-12 text-gray-500">{apartmentNumber}</p>

                    <h3 className="text-16 font-normal text-gray-800" id="title_id">
                        <Clickable
                            href={`${layoutPath}/prosjekt?finnkode=${finnkode}`}
                            target="_blank"
                            title={heading}
                            className="text-current hover:no-underline focus:no-underline"
                        >
                            {heading}
                        </Clickable>
                    </h3>

                    <p>
                        <span className="font-bold">{totalPrice && formatPriceLabel(totalPrice)}</span>
                        <span className="font-bold float-right">
                            {primaryRoomArea !== 0 && Number.isFinite(primaryRoomArea) && `${primaryRoomArea} m²`}
                        </span>
                    </p>

                    <p>
                        <span className="text-12">{Number.isFinite(floor) && `${floor}. etasje`}</span>
                        {Number.isFinite(floor) && Number.isFinite(bedrooms) && (
                            <span className="text-gray-200 mx-8">•</span>
                        )}
                        <span className="text-12">{Number.isFinite(bedrooms) && `${bedrooms} soverom`}</span>
                    </p>
                </div>
            </Card>
        );
    };

    if (!_.isEmpty(highlightedUnits)) {
        return (
            <div className="py-32">
                <h3 className="font-bold mb-16">Utvalgte enheter</h3>
                <div className="grid grid-cols-1 gap-32 sm:grid-cols-2">
                    {highlightedUnits.map(highlightedUnit => unitPreview(highlightedUnit))}
                </div>
            </div>
        );
    }
    return null;
};

export default HighlightedUnits;
